import React, { useState, useEffect, Fragment } from "react";
import { Typography, Paper, Box, Container, Tabs, Tab } from "@mui/material";
import HttpClient, { Methods } from "../../services/HttpClient";
import ProgressIndicator from "../ProgressIndicator";
import TranslationService from "../../services/TranslationService";

// Media queries
import { endpoints } from "../../constants/Endpoints";
import UploadBlock from "./upload/UploadBlock";
import { fileCategories } from "../../constants/FileTypes";

export function DocumentsView(props) {
  const [isMounted, setMounted] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [data, setData] = useState([]);

  const handleTabChange = (event, index) => {
    setTabIndex(index);
  };

  useEffect(() => {
    getData().then((_) => {
      setLoading(false);
    });

    return () => {
      setMounted(false);
    };
  }, [isMounted, props]);

  const getData = async () => {
    const response = await HttpClient.doRequest(
      Methods.GET,
      endpoints.renter.getDocuments,
      null
    );

    if (response.ok) {
      let data = await response.json();
      setData(data);
    }

    return response.ok;
  };

  return (
    <Fragment>
      {isLoading ? (
        <div style={{ width: "100%", textAlign: "center" }}>
          <ProgressIndicator />
        </div>
      ) : (
        <Container maxWidth={false} disableGutters={true}>
          <Box display="flex" flexWrap="wrap" gap={2}>
            <Box sx={{ width: { xs: "100%", lg: "66.666%", xl: "50%" } }}>
              <Paper>
                <Box p={3}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box>
                      <Typography variant="h6" gutterBottom>
                        {TranslationService.l.mijnDocumenten}
                      </Typography>
                      <Typography variant="body2">
                        {TranslationService.l.uitlegDocumentenUploaden}
                      </Typography>
                    </Box>
                    <Box>
                      <Tabs
                        value={tabIndex}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleTabChange}
                        aria-label="Tabs"
                        variant="scrollable"
                        scrollButtons={true}
                      >
                        <Tab
                          label={
                            <div>
                              {TranslationService.l.legitimatie}
                              <span>
                                {" "}
                                (
                                {
                                  data.filter(
                                    (x) =>
                                      x.fileCategory ===
                                      fileCategories.identification
                                  ).length
                                }
                                /4)
                              </span>
                            </div>
                          }
                        />
                        <Tab
                          label={
                            <div>
                              {TranslationService.l.inkomensgegevens}
                              <span>
                                {" "}
                                (
                                {
                                  data.filter(
                                    (x) =>
                                      x.fileCategory ===
                                      fileCategories.financialDetails
                                  ).length
                                }
                                /7)
                              </span>
                            </div>
                          }
                        />
                        <Tab
                          label={
                            <div>
                              {TranslationService.l.garantSteller}
                              <span>
                                {" "}
                                (
                                {
                                  data.filter(
                                    (x) =>
                                      x.fileCategory ===
                                      fileCategories.guarantor
                                  ).length
                                }
                                /9)
                              </span>
                            </div>
                          }
                        />
                        <Tab
                          label={
                            <div>
                              {TranslationService.l.additioneleDocumenten}
                              <span>
                                {" "}
                                (
                                {
                                  data.filter(
                                    (x) =>
                                      x.fileCategory ===
                                      fileCategories.additional
                                  ).length
                                }
                                /6)
                              </span>
                            </div>
                          }
                        />
                      </Tabs>
                      {tabIndex === 0 && (
                        <Box pt={4} display="flex" flexWrap="wrap" gap={2}>
                          {[0, 1, 24, 25].map((ft) => (
                            <Box
                              key={ft}
                              sx={{
                                width: { xs: "100%", sm: "33.333%", md: "25%" },
                              }}
                            >
                              <UploadBlock
                                fileType={ft}
                                fileCategory={fileCategories.identification}
                                refreshCallback={getData}
                                uploaded={
                                  data.filter((x) => x.fileType === ft).length >
                                  0
                                }
                              />
                            </Box>
                          ))}
                        </Box>
                      )}
                      {tabIndex === 1 && (
                        <Box pt={4} display="flex" flexWrap="wrap" gap={2}>
                          {[2, 3, 4, 5, 21, 22, 23].map((ft) => (
                            <Box
                              key={ft}
                              sx={{
                                width: { xs: "100%", sm: "33.333%", md: "25%" },
                              }}
                            >
                              <UploadBlock
                                fileType={ft}
                                fileCategory={fileCategories.financialDetails}
                                refreshCallback={getData}
                                uploaded={
                                  data.filter((x) => x.fileType === ft).length >
                                  0
                                }
                              />
                            </Box>
                          ))}
                        </Box>
                      )}
                      {tabIndex === 2 && (
                        <Box pt={4} display="flex" flexWrap="wrap" gap={2}>
                          {[6, 7, 8, 9, 10, 11, 12, 13, 14].map((ft) => (
                            <Box
                              key={ft}
                              sx={{
                                width: { xs: "100%", sm: "33.333%", md: "25%" },
                              }}
                            >
                              <UploadBlock
                                fileType={ft}
                                fileCategory={fileCategories.guarantor}
                                refreshCallback={getData}
                                uploaded={
                                  data.filter((x) => x.fileType === ft).length >
                                  0
                                }
                              />
                            </Box>
                          ))}
                        </Box>
                      )}
                      {tabIndex === 3 && (
                        <Box pt={4} display="flex" flexWrap="wrap" gap={2}>
                          {[15, 16, 17, 18, 19, 20].map((ft) => (
                            <Box
                              key={ft}
                              sx={{
                                width: { xs: "100%", sm: "33.333%", md: "25%" },
                              }}
                            >
                              <UploadBlock
                                fileType={ft}
                                fileCategory={fileCategories.additional}
                                refreshCallback={getData}
                                uploaded={
                                  data.filter((x) => x.fileType === ft).length >
                                  0
                                }
                              />
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Box>
        </Container>
      )}
    </Fragment>
  );
}
